import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SDKLoadingComponent } from './sdk-loading.component';

@NgModule({
  imports: [
    SDKLoadingComponent
  ],
  exports: [
    SDKLoadingComponent
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})

export class SDKLoadingModule { }
